<template lang="html">
  <v-dialog
    v-model="dialogReadmore"
    persistent
    scrollable
    max-width="500px"
    style="border-radius: 20px;"
  >
    <v-card style="border-radius: 20px;">
      <v-app-bar flat style="background: #1a222c !important;">
        <h2 style="color: white;">{{$t('ChatSide.Read.readmore')}}</h2>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text style="height: 300px; overflow-y: scroll; margin-top: 20px;">
        <span v-if="detailReadmore.detail" v-html="convert(detailReadmore.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog()">{{$t('AnswerQuestion.ok')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogReadmore: Boolean,
    detailReadmore: {}
  },
  watch: {
    dialogReadmore () {
      if (this.dialogReadmore) {
        // console.log('dialogReadmore', this.dialogReadmore)
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeReadmoreDialog', false)
    },
    convert(msg) {
      if (msg !== null && msg !== '') {
        var linkifyStr = require('linkifyjs/string')
        var str = msg
        var processedContent = linkifyStr(str)
        var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g

        if (msg.match(regex)) {
          for (var i = 0; i < msg.match(regex).length; i++) {
            processedContent = processedContent.replace('&lt;tax&gt;', `<b style="color:#1976d2; cursor:pointer;" >@`)
            processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
          }
        }
        return processedContent
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
